import {BaseConverter} from '../../base/converters/base-converter.converter';
import {OrdersResearchOptionsModel} from '../models/orders-research-options.model';
import {OrdersResearchOptions} from '../../shared/DTO/ordersResearchOptions';


export class OrdersResearchOptionsConverter extends BaseConverter<OrdersResearchOptionsModel, OrdersResearchOptions> {
  convertToDto(model: OrdersResearchOptionsModel): OrdersResearchOptions {
    if (!model) {
      return undefined;
    }
    return {
      mode: model.mode
    };
  }

  convertToModel(dto: OrdersResearchOptions): OrdersResearchOptionsModel {
    if (!dto) {
      return null;
    }

    let model: OrdersResearchOptionsModel = new OrdersResearchOptionsModel();
    model.mode = dto.mode;
    return model;
  }

}
